import React from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigation } from '../../contexts/NavigationContext';
import PrivacyPolicy from '../../pages/PrivacyPolicy';
import TermsConditions from '../../pages/TermsConditions';
import CodeOfConduct from '../../pages/CodeOfConduct';


const PageContainer = styled(motion.div)`
  min-height: 100vh;
  width: 100%;
`;

const BackButton = styled(motion.button)`
  position: fixed;
  top: 2rem;
  left: 2rem;
  z-index: 1000;
  background: ${({ theme }) => theme.colors.surface};
  border: 2px solid ${({ theme }) => theme.colors.primary.blue};
  border-radius: 50px;
  padding: 0.75rem 1.5rem;
  color: ${({ theme }) => theme.colors.primary.blue};
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  
  &:hover {
    background: ${({ theme }) => theme.colors.primary.blue};
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 6px 25px rgba(0, 128, 214, 0.3);
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    top: 1rem;
    left: 1rem;
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
  }
`;

// Home component - your existing app content
const HomePage = ({ children }) => (
  <PageContainer
    key="home"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.3 }}
  >
    {children}
  </PageContainer>
);

// Privacy page wrapper
const PrivacyPage = () => {
  const { goHome } = useNavigation();
  
  return (
    <PageContainer
      key="privacy"
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -100 }}
      transition={{ duration: 0.4 }}
    >
      <BackButton
        onClick={goHome}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        ← Back to Home
      </BackButton>
      <PrivacyPolicy />
    </PageContainer>
  );
};

// Terms page wrapper
const TermsPage = () => {
  const { goHome } = useNavigation();
  
  return (
    <PageContainer
      key="terms"
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -100 }}
      transition={{ duration: 0.4 }}
    >
      <BackButton
        onClick={goHome}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        ← Back to Home
      </BackButton>
      <TermsConditions />
    </PageContainer>
  );
};

// Terms page wrapper
const CodeOfConductPage = () => {
  const { goHome } = useNavigation();
  
  return (
    <PageContainer
      key="terms"
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -100 }}
      transition={{ duration: 0.4 }}
    >
      <BackButton
        onClick={goHome}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        ← Back to Home
      </BackButton>
      <CodeOfConduct />
    </PageContainer>
  );
};

const PageWrapper = ({ children }) => {
  const { currentPage } = useNavigation();

  return (
    <AnimatePresence mode="wait">
      {currentPage === 'home' && (
        <HomePage>{children}</HomePage>
      )}
      {currentPage === 'privacy' && <PrivacyPage />}
      {currentPage === 'terms' && <TermsPage />}
      {currentPage === 'codeofconduct' && <CodeOfConductPage />}
    </AnimatePresence>
  );
};

export default PageWrapper;